module.exports = __webpack_public_path__ + "images/enterprise-logo-white.f76e70c826420a9da381.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/enterprise-logo-white.svg
// module id = FBh/
// module chunks = 2